import { Component } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
    selector: 'cv-systemplate-status-cell-renderer',
    templateUrl: './systemplate-status-cell-renderer.component.html',
    styleUrls: ['./systemplate-status-cell-renderer.component.scss']
})
export class SystemplateStatusCellRendererComponent implements AgRendererComponent {

    params: ICellRendererParams;
    value: number;

    constructor() { }

    agInit(params: ICellRendererParams) {
        this.params = params;
        this.value = params.value;
    }

    refresh(params: ICellRendererParams) {
        this.params = params;
        this.value = params.value;
        return true;
    }

}
